import React, { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "motion/react";

const TOP_THRESHOLD = 15;

export const Navigation = (props) => {
  const [isVisible, setIsVisible] = useState(true);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    setIsVisible(latest < TOP_THRESHOLD);
  });

  return (
    <motion.nav
      id="menu"
      className="navbar navbar-default navbar-fixed-top"
      animate={{ y: isVisible ? 0 : "-100%" }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
      style={{ willChange: "transform" }}
    >
      <div className="container navbar-center">
      <img
            fetchpriority="high"
            width={200}
            src="/img/logo.png"
            className="attachment-large size-large wp-image-96 navbar-brand page-scroll"
            alt=""
          />
      </div>
    </motion.nav>
  );
};
